import Vue from "vue";

export default Vue.extend({
    name: "PartDetailsTable",
    components: {},
    props: {
        labelValuePairs: Array
    }
});
